import { Diamond } from "lucide-react";

export const fmtTime = (s) => {
  s = Math.max(0, Math.floor(s || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  return `${m}:${String(sec).padStart(2, "0")}`;
};

export function BookMark({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Diamond className="h-4 w-4 text-teal-300" strokeWidth={1.4} />
      <span className="font-mono text-[10px] uppercase tracking-[0.42em] text-teal-300/80">House Diamond</span>
    </div>
  );
}

export function ListenShell({ children, footer }) {
  return (
    <div className="fixed inset-0 flex flex-col overflow-hidden bg-[#07090d] text-slate-100">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.5]"
        style={{
          background:
            "radial-gradient(120% 80% at 50% -10%, rgba(45,212,191,0.10), transparent 60%), radial-gradient(90% 60% at 50% 110%, rgba(30,58,68,0.35), transparent 70%)",
        }}
      />
      <div className="relative flex min-h-0 flex-1 flex-col overflow-y-auto">{children}</div>
      {footer}
    </div>
  );
}
